/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings3
const seo = {
  title: "Sri Charan Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Sri Charan Portfolio",
    type: "website",
    url: "https://charanportfolio.netlify.app/#/projects",
  },
};

//Home Page
const greeting = {
  title: "Sri Charan Pabbathi",
  logo_name: "SRI CHARAN",
  nickname: "Charan",
  subTitle:
    "I am a  Computer Science Grad School student & passionate Developer 🚀 having an experience of building web applications and Analytics worked as an intern in mnc’s like Global shala , Coding Ninjas,Techlearn.live ..",
  resumeLink:
    "https://drive.google.com/file/d/13SRtHzi13oymAQudlpD9i4JMyh6nqsl4/view",
  portfolio_repository: "https://github.com/sricharan2107",
  githubProfile: "https://github.com/sricharan2107",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/sricharan2107",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sricharanpabbathi/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UCF_U6_rTUpD3qHnbW9yOT6A",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:sricharanpabbathi@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Twitter",
  //   link: "https://twitter.com/",
  //   fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
  //   backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  // },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  {
    name: "Instagram",
    link: "https://www.instagram.com/sricharan2107/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    // This data is operated from src\containers\skills\Skills.js
    // {
    //   title: "Data Science & AI",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
    //     "⚡ Experience of working with Computer Vision and NLP projects",
    //     "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Keras",
    //       fontAwesomeClassname: "simple-icons:keras",
    //       style: {
    //         backgroundColor: "white",
    //         color: "#D00000",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Full Stack Development",
    //   fileName: "FullStackImg",
    //   skills: [
    //     "⚡ Building responsive website front end using React-Redux",
    //     "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
    //     "⚡ Creating application backend in Node, Express & Flask",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "HTML5",
    //       fontAwesomeClassname: "simple-icons:html5",
    //       style: {
    //         color: "#E34F26",
    //       },
    //     },
    //     {
    //       skillName: "CSS3",
    //       fontAwesomeClassname: "fa-css3",
    //       style: {
    //         color: "#1572B6",
    //       },
    //     },
    //     {
    //       skillName: "Sass",
    //       fontAwesomeClassname: "simple-icons:sass",
    //       style: {
    //         color: "#CC6699",
    //       },
    //     },
    //     {
    //       skillName: "JavaScript",
    //       fontAwesomeClassname: "simple-icons:javascript",
    //       style: {
    //         backgroundColor: "#000000",
    //         color: "#F7DF1E",
    //       },
    //     },
    //     {
    //       skillName: "ReactJS",
    //       fontAwesomeClassname: "simple-icons:react",
    //       style: {
    //         color: "#61DAFB",
    //       },
    //     },
    //     {
    //       skillName: "NodeJS",
    //       fontAwesomeClassname: "simple-icons:node-dot-js",
    //       style: {
    //         color: "#339933",
    //       },
    //     },
    //     {
    //       skillName: "NPM",
    //       fontAwesomeClassname: "simple-icons:npm",
    //       style: {
    //         color: "#CB3837",
    //       },
    //     },
    //     {
    //       skillName: "Yarn",
    //       fontAwesomeClassname: "simple-icons:yarn",
    //       style: {
    //         color: "#2C8EBB",
    //       },
    //     },
    //     {
    //       skillName: "Gatsby",
    //       fontAwesomeClassname: "simple-icons:gatsby",
    //       style: {
    //         color: "#663399",
    //       },
    //     },
    //     {
    //       skillName: "Flutter",
    //       fontAwesomeClassname: "simple-icons:flutter",
    //       style: {
    //         color: "#02569B",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "Cloud Infra-Architecture",
    //   fileName: "CloudInfraImg",
    //   skills: [
    //     "⚡ Experience working on multiple cloud platforms",
    //     "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
    //     "⚡ Deploying deep learning models on cloud to use on mobile devices",
    //     "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "GCP",
    //       fontAwesomeClassname: "simple-icons:googlecloud",
    //       style: {
    //         color: "#4285F4",
    //       },
    //     },
    //     {
    //       skillName: "AWS",
    //       fontAwesomeClassname: "simple-icons:amazonaws",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Azure",
    //       fontAwesomeClassname: "simple-icons:microsoftazure",
    //       style: {
    //         color: "#0089D6",
    //       },
    //     },
    //     {
    //       skillName: "Firebase",
    //       fontAwesomeClassname: "simple-icons:firebase",
    //       style: {
    //         color: "#FFCA28",
    //       },
    //     },
    //     {
    //       skillName: "PostgreSQL",
    //       fontAwesomeClassname: "simple-icons:postgresql",
    //       style: {
    //         color: "#336791",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       fontAwesomeClassname: "simple-icons:mongodb",
    //       style: {
    //         color: "#47A248",
    //       },
    //     },
    //     {
    //       skillName: "Docker",
    //       fontAwesomeClassname: "simple-icons:docker",
    //       style: {
    //         color: "#1488C6",
    //       },
    //     },
    //     {
    //       skillName: "Kubernetes",
    //       fontAwesomeClassname: "simple-icons:kubernetes",
    //       style: {
    //         color: "#326CE5",
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/sricharan210701",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/sricharan2107",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://codeforces.com/profile/sricharan2107",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@sri1163",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Florida",
      subtitle: "Master's in computer and  informations Sciences",
      logo_path: "uf_logo.png",
      alt_name: "MLRIT Hyderabad",
      duration: "August 2023 - August 2025",
      descriptions: [
        "⚡ Focus on developing Data Structures and Algorithms (DSA) skills and honing problem-solving techniques for advanced computer science concepts.",
        "⚡ Advanced Data Structures: Binomial heaps, Tournament trees, Amortized complexity.",
        "⚡ Database Management System: Relational Data model, Relational Algebra, SQL.",
        "⚡ Distributed Operating Systems: Socket APIs, Interprocess Communication, Vector Logical Clocks, Kernel thread implementation.",
      ],
      website_link: "https://www.ufl.edu",
    },
    {
      title: "MLR Institute of Technology",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "mlrit_logo.png",
      alt_name: "MLRIT Hyderabad",
      duration: "2019 - 2023",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ During the campus placements, I have got a full time oppurtunity as a software devloment engineer at Virtusa."
        
      ],
      website_link: "https://mlrit.ac.in",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Programming for Everybody",
      subtitle: "- Getting Started with Python",
      logo_path: "um.jpg",
      certificate_link:
        "https://coursera.org/share/f5b9ef3c9e8e6fd6da044dbc3c71ebfd",
      alt_name: "University of Michigan",
      color_code: "#8C151599",
    },
    {
      title: "AWS Fundamentals ",
      subtitle: "- Going Cloud-Native",
      logo_path: "aws.jpg",
      certificate_link:
        "https://coursera.org/share/85c14d3d925c050f87d6ccf2a7487850",
      alt_name: "awsfundamentals",
      color_code: "#00000099",
    },
    {
      title: "Google Kick Start",
      subtitle: "- Coding Contest",
      logo_path: "google_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1TPQfYzm8LP57QYdQIhaJ2Kp211VfqOvN/view?usp=sharing",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Intel Open VINO TOOL KIT",
      subtitle: "- Cloud",
      logo_path: "intel.jpg",
      certificate_link:
        "https://drive.google.com/file/d/10MG_NWYCKjnGsDOyrRzXsZbvh3D8971Y/view?usp=sharing",
      alt_name: "modifest",
      color_code: "#1F70C199",
    },
    {
      title: "Tech Learn",
      subtitle: "- Business Devlopment",
      logo_path: "tlearn.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1LMBHSB-Qh8LeOhfNk-BbHQqhkMdy5kKM/view?usp=sharing",
      alt_name: "tlearn",
      color_code: "#D83B0199",
    },
    {
      title: "Coding Ninjas",
      subtitle: "- Achiver's Pass",
      logo_path: "codingninja.png",
      certificate_link:
        "https://drive.google.com/file/d/1sA-LxqFx4meRo4Yi8yEizKQRVfnxUIaR/view?usp=sharing",
      alt_name: "coding ninjas",
      color_code: "#1F70C199",
    },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    // {
    //   title: "DL on Tensorflow",
    //   subtitle: "- Laurence Moroney",
    //   logo_path: "deeplearning_ai_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    // {
    //   title: "Cryptography",
    //   subtitle: "- Saurabh Mukhopadhyay",
    //   logo_path: "nptel_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    //   alt_name: "NPTEL",
    //   color_code: "#FFBB0099",
    // },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internship and Volunteership",
  description:
    "",
  header_image_path: "experience.svg",
  sections: [
    // {
    //   title: "Work",
    //   experiences: [
        // {
        //   title: "Associate AI Engineer",
        //   company: "Legato Health Technology",
        //   company_url: "https://legatohealthtech.com/",
        //   logo_path: "legato_logo.png",
        //   duration: "June 2020 - PRESENT",
        //   location: "Hyderabad, Telangana",
        //   description:
        //     "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
        //   color: "#0879bf",
        // },
        // {
        //   title: "Android and ML Developer",
        //   company: "Muffito Incorporation",
        //   company_url: "https://www.linkedin.com/company/muffito-inc/about/",
        //   logo_path: "muffito_logo.png",
        //   duration: "May 2018 - Oct 2018",
        //   location: "Pune, Maharashtra",
        //   description:
        //     "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
        //   color: "#9b1578",
        // },
        // {
        //   title: "Android Developer",
        //   company: "FreeCopy Pvt. Ltd.",
        //   company_url: "https://www.linkedin.com/company/freecopy/about/",
        //   logo_path: "freecopy_logo.png",
        //   duration: "Nov 2017 - Dec 2017",
        //   location: "Ahmedabad, Gujarat",
        //   description:
        //     "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
        //   color: "#fc1f20",
        // },
    //   ],
    // },
    {
      title: "Internships",
      experiences: [
        {
          title: "Virtusa Pvt Ltd - Summer SDE Intern",
          company: "Virtusa Pvt. Ltd.",
          company_url: "https://globalshala.com/",
          logo_path: "virtusa.png",
          duration: "Dec 2022 – Jun 2023",
          location: "Hyderabad, Telangana",
          description:
            "Collaborated in a 6-member Agile team for .NET development, contributing to both frontend and backend tasks. Designed and implemented reusable Angular 11 components (AG-GRID, high-charts, renderers, pipes, directives) and successfully migrated applications from Grails to .NET Core, enhancing productivity by 40%.",
          color: "#0071C5",
        },
        {
          title: "Data Analyst Intern",
          company: "Global Shala Pvt. Ltd.",
          company_url: "https://globalshala.com/",
          logo_path: "globalshala_logo.png",
          duration: "Feb 2022 - April 2022",
          location: "Hyderabad, Telangana",
          description:
            "Maintained large databases and used various professional statistical techniques to collect, analyze, and interpret data from customers and partners. Worked on the development and implementation of new quantitative models in order to stabilize the business and maximize efficiency.",
          color: "#0071C5",
        },
        {
          title: "Ninja Entreperneur",
          company: "Coding Ninjas",
          company_url:
            "https://mlrit.ac.in",
          logo_path: "codingninja.png",
          duration: "Nov 2021 - April 2022",
          location: "Hyderabad, Telangana",
          description:
            "Worked as a campus ambassador intern at Coding Ninjas for 6 months. Conducted tech shows, quizzes and Webinars in our college. This internship helped me in enriching leadership qualities and I also learnt about Business development and communication skill.",
          color: "#0071C5",
        },
        {
          title: "Web Devlopment Intern at Computer Science Department",
          company: "Conference Website",
          company_url:
            "https://mlrit.ac.in",
          logo_path: "mlrit_logo.png",
          duration: "June 2022 - Aug 2022",
          location: "Hyderabad, Telangana",
          description:
            "Devloped an International Conference website (aicc2022.com) for Computer science depeartment at MLR Institutions of technology. Function based components and hooks are used in building this React js website. Worked for 3 months under guidence of Dr S K Senthil Kumar and Dr P Chinnasaami. Used webhost box as an domain provider for hosting this website.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Vice President at Inter Student Devloper Club",
          company: "Intel",
          company_url: "https://www.intel.com/content/www/us/en/developer/community/ambassadors.html?s=Newest",
          logo_path: "intel.jpg",
          duration: "Nov 2021 - Feb 2022",
          location: "Hyderabad, Telangana",
          description:
            "Intel Devloper's club is a intel-sponsored program for university students to get started with OpenVino Toolkit. The curriculum offers 3 tracks Content (Deep Learning skills, Cutting Edge hardware and software, Innovative AI and IOT Solutions) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
          color: "#4285F4",
        },
        {
          title: "Chair Person for Technical and product devlopment at CIE",
          company: "Center for Innovation and Entrepreneurship",
          company_url: "https://mlritcie.in/",
          logo_path: "mlritcie.jpg",
          duration: "Sept 2021 - April 2023",
          location: "Hyderabad, Telangana",
          description:
            "Being an technical team Chair person I have been an organizer for many Technical and business events of CIE. Mentored Freshman students for devloping their skills and completing their micro projects.",
          color: "#D83B01",
        },
        {
          title: "External Affairs at SCOPE CLUB",
          company: "School of Programming And Programming",
          company_url: "https://scopeclub.in/",
          logo_path: "mlritscope.jpg",
          duration: "May 2020 - April 2023",
          location: "Hyderabad, Telangana",
          description:
            "We have well established Technical club in college. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops, Hackathons and activities on web Application Development, Gameing Devlopment and Programming.",
          color: "#000000",
        },
        {
          title: "Volunteer At Nss",
          company: "National Service Scheam",
          company_url:
            "https://www.instagram.com/mlritnss/",
          logo_path: "nss.png",
          duration: "June 2020 - Sept 2020",
          location: "Hyderabad, Telangana",
          description:
            "Volunteered 3 months for social causes like Poilo drive, Medical camps and plastic collection campaign under mlrit Nss unit.",
          color: "#0C9D58",
        },
        // {
        //   title: "Developer Program Member",
        //   company: "Github",
        //   company_url: "https://github.com/",
        //   logo_path: "github_logo.png",
        //   duration: "July 2019 - PRESENT",
        //   location: "Work From Home",
        //   description:
        //     "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
        //   color: "#181717",
        // },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "MDEwOlJlcG9zaXRhehe",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2022-05-13T16:26:54Z",
    //   description: "Paper Written on AI Virtual Keyboard and Mouse published in Indain ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "charan_photo.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with your Queries.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://charanportfolio.netlify.app/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "3800 SW 34th Street Apartment FF321, Gainesville, Florida, USA",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/9LqT8Xh3t3AkvfGi8",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 (352) 709-2933",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
